import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schemaJson?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  schemaJson,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:site_name', '明星黑料大全', true);
    setMeta('og:locale', 'zh_CN', true);

    if (ogImage) {
      setMeta('og:image', ogImage, true);
      setMeta('og:image:width', '1200', true);
      setMeta('og:image:height', '630', true);
      setMeta('twitter:card', 'summary_large_image');
      setMeta('twitter:image', ogImage);
    } else {
      setMeta('twitter:card', 'summary');
    }

    setMeta('twitter:title', title);
    setMeta('twitter:description', description);

    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) existingCanonical.remove();
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = canonicalUrl;
    document.head.appendChild(canonical);

    let schemaEl = document.querySelector('script[type="application/ld+json"]');
    if (schemaEl) schemaEl.remove();

    if (schemaJson) {
      schemaEl = document.createElement('script');
      schemaEl.setAttribute('type', 'application/ld+json');
      schemaEl.textContent = JSON.stringify(schemaJson, null, 2);
      document.head.appendChild(schemaEl);
    }

    return () => {
      document.querySelectorAll('script[type="application/ld+json"]').forEach((s) => s.remove());
    };
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, schemaJson]);

  return null;
}